var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"change":e => _vm.$emit('input', e)}},'a-cascader',_vm.$attrs,false),_vm.$listeners),[_c('a-icon',{attrs:{"slot":"suffixIcon","type":"caret-down"},slot:"suffixIcon"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }